import React from "react";
import {LucideIcon} from "lucide-react";
import {cn} from "./cn";

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: LucideIcon;
    label: string;
    tone?: "default" | "danger" | "primary";
    active?: boolean;
    size?: "sm" | "md";
}

const tones: Record<NonNullable<IconButtonProps["tone"]>, string> = {
    default: "text-ink-muted hover:text-ink hover:bg-surface-hover",
    danger: "text-ink-muted hover:text-error hover:bg-error-tint",
    primary: "text-primary hover:bg-primary-tint",
};

const sizes: Record<NonNullable<IconButtonProps["size"]>, { box: string; icon: number }> = {
    sm: {box: "size-9", icon: 16},
    md: {box: "size-11", icon: 18},
};

export const IconButton: React.FC<IconButtonProps> = ({
                                                            icon: Icon,
                                                            label,
                                                            tone = "default",
                                                            active,
                                                            size = "md",
                                                            className,
                                                            ...props
                                                        }) => {
    const s = sizes[size];
    return (
        <button
            aria-label={label}
            title={label}
            className={cn(
                s.box,
                "flex items-center justify-center rounded-full transition-colors duration-150",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
                active ? "bg-primary-tint text-primary" : tones[tone],
                className
            )}
            {...props}
        >
            <Icon size={s.icon} strokeWidth={2}/>
        </button>
    );
};
